import "./doctors.css"
import sphere2 from "../../assets/images/Ellipse 2.png"
import sphere3 from "../../assets/images/Ellipse 3.png"
import Doctor from "../doctor/Doctor"
import { useTranslation } from "react-i18next";

const Doctors = () => {
  const { t } = useTranslation();
  return (
    <div className="doctors-container">
      <h3>{t("doctors_section.title")}</h3>
      <p>{t("doctors_section.subtitle")}</p>

      <img className="sphere2" src={sphere2} alt="sphere2" />
      <img className="sphere3" src={sphere3} alt="sphere3" />

      <div className="doctors-wrapper">
        <Doctor />
      </div>

      <button onClick={() => window.location.href = '/doctor'}>{t("doctors_section.explore")}</button>

    </div>
  )
}

export default Doctors